import { render, staticRenderFns } from "./invoice-detail-table.vue?vue&type=template&id=4a54fb7c"
import script from "./invoice-detail-table.vue?vue&type=script&lang=js"
export * from "./invoice-detail-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports